import { api } from "@/lib/api-client";
import { TaxSystem } from "@/server-types";
import { useMemo } from "react";
import { useClientFeature } from "./useClientFeature";

export function useAvailableFiscalizationTaxSystems() {
  const { isFeatureEnabled } = useClientFeature();
  const isTaxRegisterEnabled = isFeatureEnabled("taxRegister") ?? false;

  const {
    data: fiscalizations,
    isFetched: isFiscalizationsFetched,
    isFetching: isFiscalizationsFetching,
  } = api.taxRegister.useGetTaxRegisterFiscalizations({
    enabled: isTaxRegisterEnabled,
  });

  const availableTaxSystems = useMemo<TaxSystem[]>(() => {
    return Array.from(
      new Set(
        (fiscalizations?.fiscalizations ?? []).map(
          (fiscalization) => fiscalization.taxSystem,
        ),
      ),
    );
  }, [fiscalizations]);

  const isFiscalizationsReady =
    !isTaxRegisterEnabled || isFiscalizationsFetched;

  return {
    availableTaxSystems,
    hasActiveFiscalizations:
      isTaxRegisterEnabled && availableTaxSystems.length > 0,
    isTaxRegisterEnabled,
    isFiscalizationsFetching,
    isFiscalizationsReady,
  };
}
